import React from 'react';
import Image from 'next/image';
import { AstraLogoWhite, ToyotaLogoWhite } from '../../../../assets/images';

const CopyrightIcon = () => {
  return (
    <div className="flex gap-[29px] md:gap-[50px]">
      <Image
        src={AstraLogoWhite}
        alt="astra"
        width={106}
        height={32}
        className="w-[62px] h-[17px] sm:w-24 sm:h-7 lg:w-[106px] lg:h-[32px]"
      />
      <Image
        src={ToyotaLogoWhite}
        alt="toyota"
        width={99}
        height={32}
        className="w-[57px] h-[18px] sm:w-24 sm:h-7 lg:w-[99px] lg:h-[32px]"
      />
    </div>
  );
};

export default CopyrightIcon;
